<template>
  <div class="login-container">
    <div class="login-card">
      <LoginIcon />
      <LoginForm />
    </div>
  </div>
</template>

<script>
import LoginIcon from "./fragments/login.logo.vue";
import LoginForm from "./fragments/login.form.vue";
import { mapGetters } from "vuex";
import { ROUTES } from "@/routes/pwa";

export default {
  name: "Login",

  computed: {
    ...mapGetters(["isAuthenticated"]),
  },

  created() {
    if (this.isAuthenticated) {
      this.$router.replace(ROUTES.dashboard);
    }
  },

  components: {
    LoginIcon,
    LoginForm,
  },
};
</script>

<style scoped>
.login-container {
  background: url("../../assets/img/backgrounds/login.png") center no-repeat;
  background-size: cover;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-card {
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
}
</style>
